export default __webpack_public_path__ + "static/media/ELECTIVES_PHYSICAL_EDUCATION.d8fc8787.svg";